module.exports = __webpack_public_path__ + "img/circle.bfcb02c2.svg";